"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _underscore = require("underscore");

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var DynoEditorActions = _interopRequireWildcard(require("lead-flows-ui/actions/DynoEditor"));

var ContactPropertyActions = _interopRequireWildcard(require("lead-flows-ui/actions/ContactProperties"));

var _FormFieldUtils = require("lead-flows-ui/utils/FormFieldUtils");

var _ContactPropertyUtils = require("lead-flows-ui/utils/ContactPropertyUtils");

var _Dynos = require("lead-flows-ui/selectors/Dynos");

var _ContactProperties2 = require("lead-flows-ui/selectors/ContactProperties");

var _RequestState = require("lead-flows-ui/utils/RequestState");

var _FormFieldTypes = _interopRequireDefault(require("lead-flows-ui/constants/FormFieldTypes"));

var _Scopes = require("lead-flows-ui/selectors/Scopes");

var _Scopes2 = require("lead-flows-ui/constants/Scopes");

var _ContactPropertiesCreateProperty = _interopRequireDefault(require("lead-flows-ui/components/editor/contactProperties/ContactPropertiesCreateProperty"));

var _FormFieldCreationButton = _interopRequireDefault(require("./FormFieldCreationButton"));

var DEFAULT_FIELD_TYPES = Object.values(_FormFieldTypes.default || {});
var ORDER_PUSH_OFFSET = 1000000;

var FormFieldSelect =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FormFieldSelect, _Component);
  (0, _createClass2.default)(FormFieldSelect, null, [{
    key: "propTypes",
    get: function get() {
      return {
        selectedFields: _react.PropTypes.arrayOf(_react.PropTypes.shape({
          name: _react.PropTypes.string.isRequired
        })).isRequired,
        locale: _react.PropTypes.string.isRequired,
        contactProperties: _react.PropTypes.arrayOf(_react.PropTypes.object).isRequired,
        propertyGroups: _react.PropTypes.arrayOf(_react.PropTypes.object).isRequired,
        isAbleToUseCustomProperties: _react.PropTypes.bool.isRequired,
        addFormField: _react.PropTypes.func.isRequired,
        createContactProperty: _react.PropTypes.func.isRequired,
        creationRequestState: _react.PropTypes.instanceOf(_RequestState.RequestState).isRequired,
        afterAddHandler: _react.PropTypes.func,
        gates: _react.default.PropTypes.object.isRequired
      };
    }
  }]);

  function FormFieldSelect() {
    var _this;

    (0, _classCallCheck2.default)(this, FormFieldSelect);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormFieldSelect).call(this));
    _this.state = {
      searchQuery: '',
      isCreatingNewFormField: false
    };
    _this.handleAddField = _this.handleAddField.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleAddFieldRaw = _this.handleAddFieldRaw.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCreatNewContactPropertyOpen = _this.handleCreatNewContactPropertyOpen.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCreatNewContactPropertyClose = _this.handleCreatNewContactPropertyClose.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleQueryChange = _this.handleQueryChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderItem = _this.renderItem.bind((0, _assertThisInitialized2.default)(_this));
    _this.propertySortingSelector = _this.propertySortingSelector.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(FormFieldSelect, [{
    key: "langKey",
    value: function langKey(key) {
      return "leadFlowEditor.formFieldEditor." + key;
    }
  }, {
    key: "handleCreatNewContactPropertyOpen",
    value: function handleCreatNewContactPropertyOpen() {
      this.setState({
        isCreatingNewFormField: true
      });
    }
  }, {
    key: "handleCreatNewContactPropertyClose",
    value: function handleCreatNewContactPropertyClose() {
      this.setState({
        isCreatingNewFormField: false
      });
    }
  }, {
    key: "handleAddFieldRaw",
    value: function handleAddFieldRaw(field) {
      var _this$props = this.props,
          locale = _this$props.locale,
          addFormField = _this$props.addFormField,
          afterAddHandler = _this$props.afterAddHandler;
      addFormField({
        name: field.name,
        label: (0, _FormFieldUtils.getFormFieldLabel)(field, locale),
        type: field.type,
        fieldType: field.fieldType,
        options: field.options
      });

      if ((0, _underscore.isFunction)(afterAddHandler)) {
        afterAddHandler();
      }

      this.setState({
        searchQuery: ''
      });
    }
  }, {
    key: "handleAddField",
    value: function handleAddField(event) {
      var contactProperties = this.props.contactProperties;
      var fieldName = event.target.value;
      var field = contactProperties.find(function (property) {
        return property.name === fieldName;
      });
      this.handleAddFieldRaw(field);
    }
  }, {
    key: "handleQueryChange",
    value: function handleQueryChange(newQuery) {
      this.setState({
        searchQuery: newQuery
      });
    } // Take a property and figure out where it should be placed in the Select.

  }, {
    key: "propertySortingSelector",
    value: function propertySortingSelector(property) {
      var defaultFieldIndex = DEFAULT_FIELD_TYPES.indexOf(property.name);

      if (defaultFieldIndex !== -1) {
        // Push the recommended 4 properties to the top
        // and order them in our own order.
        return defaultFieldIndex - ORDER_PUSH_OFFSET;
      } else if (!(0, _ContactPropertyUtils.isPropertyAllowedInFlows)(property)) {
        // Push disabled properies to the bottom.
        return property.displayOrder + ORDER_PUSH_OFFSET;
      }

      return property.displayOrder;
    }
  }, {
    key: "isPropertyDisabled",
    value: function isPropertyDisabled(property) {
      var isAbleToUseCustomProperties = this.props.isAbleToUseCustomProperties;
      var isDefaultProperty = (0, _underscore.contains)(DEFAULT_FIELD_TYPES, property.name);
      return !(0, _ContactPropertyUtils.isPropertyAllowedInFlows)(property) || // Isn't a default property and user can't use custom properties.
      !isDefaultProperty && !isAbleToUseCustomProperties;
    }
  }, {
    key: "generateOptions",
    value: function generateOptions() {
      var isAbleToUseCustomProperties = this.props.isAbleToUseCustomProperties;

      if (!isAbleToUseCustomProperties) {
        return this.generateFreeOptions();
      }

      return this.generateStarterOptions();
    }
  }, {
    key: "generateFreeOptions",
    value: function generateFreeOptions() {
      var _this$props2 = this.props,
          locale = _this$props2.locale,
          selectedFields = _this$props2.selectedFields;
      var selectedFieldNames = (selectedFields || []).map(function (el) {
        return el.name;
      });
      return (0, _underscore.chain)(DEFAULT_FIELD_TYPES).filter(function (fieldName) {
        return !(0, _underscore.contains)(selectedFieldNames, fieldName);
      }).map(function (name) {
        return {
          value: name,
          text: (0, _FormFieldUtils.generateFormField)({
            name: name
          }, locale).label
        };
      }).value();
    }
  }, {
    key: "generateStarterOptions",
    value: function generateStarterOptions() {
      var _this2 = this;

      var _this$props3 = this.props,
          contactProperties = _this$props3.contactProperties,
          locale = _this$props3.locale,
          propertyGroups = _this$props3.propertyGroups,
          selectedFields = _this$props3.selectedFields;

      var _filterPropertyList = (0, _ContactPropertyUtils.filterPropertyList)({
        properties: contactProperties,
        groups: propertyGroups
      }),
          properties = _filterPropertyList.properties;

      var selectedFieldNames = (selectedFields || []).map(function (el) {
        return el.name;
      });
      return (0, _underscore.chain)(properties).filter( // Take only those that aren't already selected.
      function (property) {
        return !(0, _underscore.contains)(selectedFieldNames, property.name);
      }).groupBy( // Group them by their groupName.
      function (property) {
        return property.groupName;
      }).map( // Transform them to what UISelect wants.
      function (groupProperties, groupName) {
        var options = (0, _underscore.chain)(groupProperties).sortBy(_this2.propertySortingSelector).map(function (property) {
          return {
            text: (0, _FormFieldUtils.getFormFieldLabel)(property, locale),
            value: property.name,
            disabled: _this2.isPropertyDisabled(property)
          };
        }).value();
        return {
          value: groupName,
          text: (0, _underscore.findWhere)(propertyGroups, {
            name: groupName
          }).displayName,
          options: options
        };
      }).values().sortBy(function (group) {
        return group.value;
      }).value();
    }
  }, {
    key: "renderItem",
    value: function renderItem(_ref) {
      var option = _ref.option,
          children = _ref.children;

      if (option.disabled) {
        return _react.default.createElement(_UITooltip.default, {
          placement: "right",
          title: _react.default.createElement(_FormattedMessage.default, {
            message: this.langKey('fieldNotAllowed')
          }),
          delay: 200
        }, children);
      }

      return _react.default.createElement("span", null, children);
    }
  }, {
    key: "renderFieldCreationButton",
    value: function renderFieldCreationButton() {
      var _this$props4 = this.props,
          contactProperties = _this$props4.contactProperties,
          creationRequestState = _this$props4.creationRequestState,
          isAbleToUseCustomProperties = _this$props4.isAbleToUseCustomProperties;
      var newPropertyLabel = this.state.searchQuery;
      var isLabelValid = (0, _ContactPropertyUtils.isValidNewProperty)(newPropertyLabel, contactProperties);
      return _react.default.createElement(_FormFieldCreationButton.default, {
        fieldLabel: newPropertyLabel,
        isValid: isLabelValid,
        onClick: this.handleCreatNewContactPropertyOpen,
        creationRequestState: creationRequestState,
        isTeaser: !isAbleToUseCustomProperties
      });
    }
  }, {
    key: "renderContactPropertyModal",
    value: function renderContactPropertyModal() {
      return _react.default.createElement(_ContactPropertiesCreateProperty.default, {
        isModalOpened: this.state.isCreatingNewFormField,
        handleAddField: this.handleAddFieldRaw,
        handleModalClose: this.handleCreatNewContactPropertyClose
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("span", null, _react.default.createElement(_UISelect.default, {
        className: "form-field-select m-bottom-2",
        placeholder: _I18n.default.text(this.langKey('selectOrCreateFieldPrompt')),
        options: this.generateOptions(),
        itemComponent: this.renderItem,
        dropdownFooter: this.renderFieldCreationButton(),
        onInputChange: this.handleQueryChange,
        onChange: this.handleAddField
      }), this.renderContactPropertyModal());
    }
  }]);
  return FormFieldSelect;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    contactProperties: (0, _ContactProperties2.getProperties)(state),
    propertyGroups: (0, _ContactProperties2.getGroups)(state),
    selectedFields: (0, _Dynos.getFormFields)(state),
    locale: (0, _Dynos.getLocale)(state),
    creationRequestState: (0, _ContactProperties2.getCreationRequestState)(state),
    isAbleToUseCustomProperties: (0, _Scopes.hasScope)(state, _Scopes2.LEAD_FLOWS_CUSTOM_FIELDS_ACCESS),
    gates: state.gates
  };
};

var actionsToBind = {
  addFormField: DynoEditorActions.addFormField,
  createContactProperty: ContactPropertyActions.createContactProperty
};

var _default = (0, _reactRedux.connect)(mapStateToProps, actionsToBind)(FormFieldSelect);

exports.default = _default;
module.exports = exports.default;